/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-west-1',
  aws_cloud_logic_custom: [
    {
      name: 'estimateApi',
      endpoint: 'https://kwy0jqwi63.execute-api.us-west-1.amazonaws.com/main',
      region: 'us-west-1',
    },
    {
      name: 'aiConsultant',
      endpoint: 'https://2rb4ajal7g.execute-api.us-west-1.amazonaws.com/main',
      region: 'us-west-1',
    },
  ],
  aws_dynamodb_all_tables_region: 'us-west-1',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'Estimates-dev',
      region: 'us-west-1',
    },
  ],
};

export default awsmobile;
